(() => {
  'use strict';
  if (window.proTierNativeCardsBound) return;
  window.proTierNativeCardsBound = true;
  document.addEventListener('change', event => {
    if (!(event.target instanceof HTMLSelectElement)) return;
    const select = event.target;
    const form = select.closest('.pt-native-card-form');
    if (!form || select.name !== 'id') return;
    const option = select.selectedOptions[0];
    const card = form.closest('.pt-shopping__card');
    if (!option || !card) return;
    const price = card.querySelector('.pt-shopping__price');
    if (price) price.textContent = option.dataset.price || '';
    const size = card.querySelector('.pt-shopping__size');
    if (size) size.textContent = [option.dataset.title === 'Default Title' ? '' : option.dataset.title, option.dataset.sku].filter(Boolean).join(' · ');
    const link = card.querySelector('.pt-shopping__link');
    if (link) {
      const url = new URL(link.href, location.origin);
      url.searchParams.set('variant', option.value);
      link.href = url.pathname + url.search;
    }
    const quantity = form.querySelector('[name="quantity"]');
    const stock = Number(option.dataset.stock);
    if (quantity instanceof HTMLInputElement && Number.isSafeInteger(stock) && stock > 0) {
      quantity.max = String(stock);
      if (Number(quantity.value) > stock) quantity.value = String(stock);
    }
    const image = card.querySelector('.pt-shopping__media img');
    if (image && option.dataset.image) {
      image.removeAttribute('srcset');
      image.src = window.ProTierImageRepair?.resolve(option.dataset.image,card.dataset.productHandle) || option.dataset.image;
    }
  });
})();

